import _asyncToGenerator from '@babel/runtime/helpers/esm/asyncToGenerator';
import _objectSpread from '@babel/runtime/helpers/esm/objectSpread2';
import _slicedToArray from '@babel/runtime/helpers/esm/slicedToArray';
import { useState, useMemo, useEffect } from 'react';
import { Button } from '@lendi-ui/button';
import Grid from '@lendi-ui/grid';
import Email from '@lendi-ui/icon/Email';
import Error$1 from '@lendi-ui/icon/Error';
import Help from '@lendi-ui/icon/Help';
import Phone from '@lendi-ui/icon/PhoneAndroid';
import TextArea from '@lendi-ui/text-area';
import { Input } from '@lendi-ui/text-input';
import { Heading, Body } from '@lendi-ui/typography';
import { Text, Spacer } from '@lendi/ui';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import _taggedTemplateLiteral from '@babel/runtime/helpers/esm/taggedTemplateLiteral';
import Alert from '@lendi-ui/alert';
import { gte } from '@lendi-ui/breakpoint';
import { fg } from '@lendi-ui/color';
import getColour from '@lendi-ui/commons/colours';
import Container from '@lendi-ui/container';
import { Select } from '@lendi-ui/dropdown';
import { my, mb, p } from '@lendi-ui/spacing';
import LendiTooltip from '@lendi-ui/tooltip';
import styled from 'styled-components';
import { jsxs, jsx } from 'react/jsx-runtime';

function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return e;
  };
  var t,
    e = {},
    r = Object.prototype,
    n = r.hasOwnProperty,
    o = Object.defineProperty || function (t, e, r) {
      t[e] = r.value;
    },
    i = "function" == typeof Symbol ? Symbol : {},
    a = i.iterator || "@@iterator",
    c = i.asyncIterator || "@@asyncIterator",
    u = i.toStringTag || "@@toStringTag";
  function define(t, e, r) {
    return Object.defineProperty(t, e, {
      value: r,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), t[e];
  }
  try {
    define({}, "");
  } catch (t) {
    define = function (t, e, r) {
      return t[e] = r;
    };
  }
  function wrap(t, e, r, n) {
    var i = e && e.prototype instanceof Generator ? e : Generator,
      a = Object.create(i.prototype),
      c = new Context(n || []);
    return o(a, "_invoke", {
      value: makeInvokeMethod(t, r, c)
    }), a;
  }
  function tryCatch(t, e, r) {
    try {
      return {
        type: "normal",
        arg: t.call(e, r)
      };
    } catch (t) {
      return {
        type: "throw",
        arg: t
      };
    }
  }
  e.wrap = wrap;
  var h = "suspendedStart",
    l = "suspendedYield",
    f = "executing",
    s = "completed",
    y = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var p = {};
  define(p, a, function () {
    return this;
  });
  var d = Object.getPrototypeOf,
    v = d && d(d(values([])));
  v && v !== r && n.call(v, a) && (p = v);
  var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p);
  function defineIteratorMethods(t) {
    ["next", "throw", "return"].forEach(function (e) {
      define(t, e, function (t) {
        return this._invoke(e, t);
      });
    });
  }
  function AsyncIterator(t, e) {
    function invoke(r, o, i, a) {
      var c = tryCatch(t[r], t, o);
      if ("throw" !== c.type) {
        var u = c.arg,
          h = u.value;
        return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) {
          invoke("next", t, i, a);
        }, function (t) {
          invoke("throw", t, i, a);
        }) : e.resolve(h).then(function (t) {
          u.value = t, i(u);
        }, function (t) {
          return invoke("throw", t, i, a);
        });
      }
      a(c.arg);
    }
    var r;
    o(this, "_invoke", {
      value: function (t, n) {
        function callInvokeWithMethodAndArg() {
          return new e(function (e, r) {
            invoke(t, n, e, r);
          });
        }
        return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(e, r, n) {
    var o = h;
    return function (i, a) {
      if (o === f) throw new Error("Generator is already running");
      if (o === s) {
        if ("throw" === i) throw a;
        return {
          value: t,
          done: !0
        };
      }
      for (n.method = i, n.arg = a;;) {
        var c = n.delegate;
        if (c) {
          var u = maybeInvokeDelegate(c, n);
          if (u) {
            if (u === y) continue;
            return u;
          }
        }
        if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) {
          if (o === h) throw o = s, n.arg;
          n.dispatchException(n.arg);
        } else "return" === n.method && n.abrupt("return", n.arg);
        o = f;
        var p = tryCatch(e, r, n);
        if ("normal" === p.type) {
          if (o = n.done ? s : l, p.arg === y) continue;
          return {
            value: p.arg,
            done: n.done
          };
        }
        "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg);
      }
    };
  }
  function maybeInvokeDelegate(e, r) {
    var n = r.method,
      o = e.iterator[n];
    if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y;
    var i = tryCatch(o, e.iterator, r.arg);
    if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y;
    var a = i.arg;
    return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y);
  }
  function pushTryEntry(t) {
    var e = {
      tryLoc: t[0]
    };
    1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e);
  }
  function resetTryEntry(t) {
    var e = t.completion || {};
    e.type = "normal", delete e.arg, t.completion = e;
  }
  function Context(t) {
    this.tryEntries = [{
      tryLoc: "root"
    }], t.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(e) {
    if (e || "" === e) {
      var r = e[a];
      if (r) return r.call(e);
      if ("function" == typeof e.next) return e;
      if (!isNaN(e.length)) {
        var o = -1,
          i = function next() {
            for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next;
            return next.value = t, next.done = !0, next;
          };
        return i.next = i;
      }
    }
    throw new TypeError(typeof e + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), o(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) {
    var e = "function" == typeof t && t.constructor;
    return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name));
  }, e.mark = function (t) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t;
  }, e.awrap = function (t) {
    return {
      __await: t
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () {
    return this;
  }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) {
    void 0 === i && (i = Promise);
    var a = new AsyncIterator(wrap(t, r, n, o), i);
    return e.isGeneratorFunction(r) ? a : a.next().then(function (t) {
      return t.done ? t.value : a.next();
    });
  }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () {
    return this;
  }), define(g, "toString", function () {
    return "[object Generator]";
  }), e.keys = function (t) {
    var e = Object(t),
      r = [];
    for (var n in e) r.push(n);
    return r.reverse(), function next() {
      for (; r.length;) {
        var t = r.pop();
        if (t in e) return next.value = t, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, e.values = values, Context.prototype = {
    constructor: Context,
    reset: function (e) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t);
    },
    stop: function () {
      this.done = !0;
      var t = this.tryEntries[0].completion;
      if ("throw" === t.type) throw t.arg;
      return this.rval;
    },
    dispatchException: function (e) {
      if (this.done) throw e;
      var r = this;
      function handle(n, o) {
        return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o;
      }
      for (var o = this.tryEntries.length - 1; o >= 0; --o) {
        var i = this.tryEntries[o],
          a = i.completion;
        if ("root" === i.tryLoc) return handle("end");
        if (i.tryLoc <= this.prev) {
          var c = n.call(i, "catchLoc"),
            u = n.call(i, "finallyLoc");
          if (c && u) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          } else if (c) {
            if (this.prev < i.catchLoc) return handle(i.catchLoc, !0);
          } else {
            if (!u) throw new Error("try statement without catch or finally");
            if (this.prev < i.finallyLoc) return handle(i.finallyLoc);
          }
        }
      }
    },
    abrupt: function (t, e) {
      for (var r = this.tryEntries.length - 1; r >= 0; --r) {
        var o = this.tryEntries[r];
        if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) {
          var i = o;
          break;
        }
      }
      i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null);
      var a = i ? i.completion : {};
      return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a);
    },
    complete: function (t, e) {
      if ("throw" === t.type) throw t.arg;
      return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y;
    },
    finish: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y;
      }
    },
    catch: function (t) {
      for (var e = this.tryEntries.length - 1; e >= 0; --e) {
        var r = this.tryEntries[e];
        if (r.tryLoc === t) {
          var n = r.completion;
          if ("throw" === n.type) {
            var o = n.arg;
            resetTryEntry(r);
          }
          return o;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (e, r, n) {
      return this.delegate = {
        iterator: values(e),
        resultName: r,
        nextLoc: n
      }, "next" === this.method && (this.arg = t), y;
    }
  }, e;
}

var LENDER_LIST = [{
  label: 'Adelaide Bank',
  value: '3df43c08-cd59-431d-bf40-6102011b5224'
}, {
  label: 'Adelaide Bank (Commercial)',
  value: '5f97f0f9-4c63-4a66-970b-c57adaa43fa7'
}, {
  label: 'Advantedge',
  value: '1a54f7de-ba65-11e9-a2a3-2a2ae2dbcce4'
}, {
  label: 'ALI',
  value: 'b2bfda90-dd16-402a-bb29-771331bcf09f'
}, {
  label: 'Allianz',
  value: 'a4eb0548-fd72-49d9-82c2-0234e9fb4756'
}, {
  label: 'AMP Bank',
  value: 'e58f4fe4-e6d8-4d19-a0bf-b21555ec0dc8'
}, {
  label: 'ANZ',
  value: '528756f9-6187-493e-861d-39c93cb3359f'
}, {
  label: 'Aussie Activate',
  value: '95f2669a-93fc-44dd-b523-a3ac761652e2'
}, {
  label: 'Aussie Asset Finance',
  value: '9b1feb7e-3606-4416-a989-95d86ddabeaf'
}, {
  label: 'Aussie Elevate',
  value: '2c080a68-c47d-4f2c-84f6-82f0b5f04c4d'
}, {
  label: 'Aussie IQ',
  value: '34f93529-3915-4809-980d-ba027fd3fbb6'
}, {
  label: 'Aussie Origin',
  value: '743468a3-8f91-4198-8242-784b9ee034e6'
}, {
  label: 'Aussie Select',
  value: 'c9389062-0da2-41c0-8f4e-689690da37f7'
}, {
  label: 'Australian Military Bank',
  value: '620b3078-60a0-44fe-9a5f-15063d1d2d57'
}, {
  label: 'Auswide Bank',
  value: 'f39e9b09-4b13-4dfc-918d-f08507d6837e'
}, {
  label: 'B&E',
  value: 'f5eea226-083b-4829-9126-2398ac01b423'
}, {
  label: 'Bank Australia',
  value: '283b98d8-2049-4a5d-8517-fa2b647b652a'
}, {
  label: 'Bank of Melbourne',
  value: '9d26c778-dcaf-4f48-9b41-37cf94646123'
}, {
  label: 'Bank of Queensland',
  value: '97511c5d-3484-4ce4-b1ef-a5b4f1e9d7a2'
}, {
  label: 'Bank of Sydney',
  value: '0ea282e2-6c79-474e-8d3a-50e9e9bb1b4b'
}, {
  label: 'Bank SA',
  value: 'd85f2579-c5f6-4c01-a7de-3af9d6eb6606'
}, {
  label: 'BankMeCU',
  value: 'e70a4057-c1b4-412b-ada3-3ff4c0305200'
}, {
  label: 'BankVic',
  value: '6e5fd018-d053-438d-a87c-7f09d3f3a596'
}, {
  label: 'Bankwest',
  value: '42b41c3c-cded-403d-b687-3387915fe692'
}, {
  label: 'BCU',
  value: '2646e225-115c-4643-96e5-6f99f866146b'
}, {
  label: 'Bendigo Bank',
  value: 'f773f266-4d54-4e91-b533-7187481b7f16'
}, {
  label: 'Better Choice Home Loans',
  value: '5dbcab86-d8c1-490d-b112-7bee0e65a9cf'
}, {
  label: 'Beyond Bank',
  value: 'd66212e8-6bf0-4bb4-b44b-19130a09c2fb'
}, {
  label: 'Big Sky Building Society',
  value: '0a72d08b-7bbd-43a2-9d96-a79043139363'
}, {
  label: 'Bluebay Home Loans',
  value: '4e6e954e-a794-465e-92cd-3bdd86cd3c1e'
}, {
  label: 'Bluestone',
  value: 'db767211-0ef4-4c0a-a064-cb283f316e92'
}, {
  label: 'BMM',
  value: '81a72d9c-0c39-44d5-8b19-869efa66a52b'
}, {
  label: 'BMM (Commercial)',
  value: '515c07ad-f42e-4823-a962-68fa12ba3e3a'
}, {
  label: 'Carrington',
  value: '9f6368a5-a7bb-460a-bd20-cb02b7a2402a'
}, {
  label: 'CBA Warehouse',
  value: '849c7f75-120a-404b-b3f7-3c5fd79ccc6b'
}, {
  label: 'Citibank',
  value: 'fc4370aa-f954-4027-8d47-d3ba0f812c25'
}, {
  label: 'Click Loans',
  value: '52b935a0-1e06-4497-a3b0-1cd0814dfe19'
}, {
  label: 'Commonwealth Bank',
  value: 'e6952a59-fc0c-43de-9791-3ab57f7a7b45'
}, {
  label: 'Community First Credit Union',
  value: '3da63774-d1d0-46f5-9d56-bda799710ccf'
}, {
  label: 'Connective HL Essentials by Advantedge',
  value: 'adfac0a5-a900-4e89-a6ca-d62c5b0beef2'
}, {
  label: 'Connective Select',
  value: '7e1ecc30-9838-4ecf-b3c1-6ce25600b0da'
}, {
  label: 'CUA',
  value: '2e8a55dd-36bc-41c4-80fd-bca424427475'
}, {
  label: 'Defence Bank',
  value: '40ad201b-769b-489d-b475-beb0c3e562f5'
}, {
  label: 'eMoney',
  value: '9ffef499-88f4-4b01-9ed3-a22e5cbdd520'
}, {
  label: 'Firefighter',
  value: 'b2722b16-ca94-11e8-a8d5-f2801f1b9fd1'
}, {
  label: 'Firstmac',
  value: '702aea7f-a73b-4ada-be42-e27cbea11c0b'
}, {
  label: 'Gateway Bank',
  value: 'f91fe806-13d1-4631-b418-4defbea8a30f'
}, {
  label: 'GE CBA',
  value: '927a36df-c034-42f4-83ee-ab3824742ebe'
}, {
  label: 'GE Money',
  value: '1672629f-76c5-470c-bc26-f2c6aa22594f'
}, {
  label: 'Genworth',
  value: '1a54fa40-ba65-11e9-a2a3-2a2ae2dbcce4'
}, {
  label: 'Great Southern Bank',
  value: '4fa5f1cc-1c5a-4432-8ee2-c70ce9987376'
}, {
  label: 'Health Professionals Bank',
  value: '09935adf-9ffe-4396-8104-666c78202ae0'
}, {
  label: 'Heritage',
  value: '90284860-0ba4-4ac7-9e4f-ae2ba1bbb97d'
}, {
  label: 'Homeloans (Commercial)',
  value: '4218b910-644e-4816-8629-6e9263efa795'
}, {
  label: 'HomeStart',
  value: '950e9887-f4f5-4e8a-bb17-cc2ae29b5737'
}, {
  label: 'HSBC',
  value: '994daa78-8c03-4903-a1db-bd98b7871649'
}, {
  label: 'Iden Group',
  value: '95bd34bf-6cf7-4118-8c11-b08b26a9553a'
}, {
  label: 'Illawarra Credit Union',
  value: 'a330ef2a-9f7a-444e-9a53-ba0b71b91097'
}, {
  label: 'IMB',
  value: '908fba70-3c09-465f-a7a4-7b5528c6efe7'
}, {
  label: 'IMB Building Society (Commercial)',
  value: 'a7cd1eef-9cbd-4d66-b31e-8a3a10ec3a49'
}, {
  label: 'ING',
  value: '3c8cef11-b39f-453f-98bf-0cee165e07c4'
}, {
  label: 'ING Direct (Commercial)',
  value: 'e667c6ba-840d-4e2c-a7ca-e095390ea717'
}, {
  label: 'KeyStart',
  value: '55e0038f-0292-4ea8-8175-7c4e2f763285'
}, {
  label: 'La Trobe Financial',
  value: 'c1180a03-5b26-4846-9df8-26fc7b49129e'
}, {
  label: 'Lendi Exclusive',
  value: '10157c72-7060-44c3-9fb6-5716c1d19256'
}, {
  label: 'Liberty',
  value: 'e473a9fe-39ee-401f-a1dd-b156932565c0'
}, {
  label: 'Loan Ave',
  value: '12139d67-5e30-48b2-8c2b-53e7ccd60c75'
}, {
  label: 'Macquarie',
  value: '7a35e036-a907-4a09-b68d-11d11e9ed94b'
}, {
  label: 'Macquarie Credit Union',
  value: 'f0e7dae3-2cc6-4331-821f-1a4795d9d376'
}, {
  label: 'ME Bank',
  value: '5ad367b4-2e4a-4b8f-9d30-5b0e7b9fa7e3'
}, {
  label: 'Merchant Mortgages',
  value: '35f250d9-6630-4772-a1af-4edf23bead7b'
}, {
  label: 'MKM Capital',
  value: 'b71573c6-b7ed-4b05-92b9-25d65d233ead'
}, {
  label: 'My Credit Union',
  value: '3662088d-be26-444c-a5e9-201744f0c772'
}, {
  label: 'My State',
  value: '9d128e66-3317-46cb-9a11-ea244e4bf46f'
}, {
  label: 'NAB',
  value: 'fae7b3fa-e4c6-485e-8ada-3f75664e5ac4'
}, {
  label: 'NAB Broker',
  value: '70e849c4-95a3-4306-a089-19885a9d6714'
}, {
  label: 'Newcastle Permanent',
  value: '3f23bf35-d6a1-436b-a9c8-ca66154f3305'
}, {
  label: 'OneTwo',
  value: '4d2c3a09-1661-45c4-a4da-d314b55251df'
}, {
  label: 'Origin Finance',
  value: '1a54fb94-ba65-11e9-a2a3-2a2ae2dbcce4'
}, {
  label: 'Origin MMS',
  value: '489fbe76-ba65-11e9-a2a3-2a2ae2dbcce4'
}, {
  label: 'P&N Bank',
  value: '9ad89592-0cf9-4736-a92e-92e857199800'
}, {
  label: 'Paramount Mortgage Services',
  value: 'b72a668f-8b66-4f0a-b779-8521529e4b91'
}, {
  label: "People's Choice Credit Union",
  value: '96245421-0cfa-40bd-96ae-b16d2ca9d0b2'
}, {
  label: 'Pepper',
  value: 'c6ac2780-ceff-4d8d-a539-655d9fe28d3d'
}, {
  label: 'Phoenix',
  value: '3dd1e0e7-b7d6-4af2-a969-79db927bd073'
}, {
  label: 'Platform Finance',
  value: '14cfda93-7116-4135-b132-81eaa7bbfadf'
}, {
  label: 'Platform Finance',
  value: '14cfda93-7116-4135-b132-81eaa7bbfadf'
}, {
  label: 'Police Bank',
  value: 'feae7e8d-5790-4b3e-80b2-2dbe0399afa9'
}, {
  label: 'Police Credit Union',
  value: '46f68b04-a92b-4164-9015-c4ba9f841d52'
}, {
  label: 'Qantas Credit Union',
  value: 'a54d8907-bb7e-4375-9ad2-ab48b82fc07b'
}, {
  label: 'QBE',
  value: '489fc0ec-ba65-11e9-a2a3-2a2ae2dbcce4'
}, {
  label: 'RAMS',
  value: 'a4f5e2bd-0e6c-482e-b028-b91b1e5c868c'
}, {
  label: 'Residential Mortgage Group',
  value: 'a6398faa-c932-422a-b5fb-c84e8225f860'
}, {
  label: 'Resimac',
  value: '489fc240-ba65-11e9-a2a3-2a2ae2dbcce4'
}, {
  label: 'Resimac Home Loans',
  value: '0e0642ad-fede-4574-b078-15e1c554aa0e'
}, {
  label: 'St.George',
  value: '280a1045-1ea4-452f-9348-2ae6b53b900b'
}, {
  label: 'Suncorp (Commercial)',
  value: '0af2388d-06e7-4ea9-9552-5509a46fbb23'
}, {
  label: 'Suncorp Bank',
  value: 'd9b81a02-97d3-4017-a495-1094c1fe6afd'
}, {
  label: 'Teachers Mutual Bank',
  value: '7fa1fb60-b1d2-400b-9224-33618724abcb'
}, {
  label: 'The Rock',
  value: '79bc1e3b-e9bd-43bb-8cdb-bf548492a045'
}, {
  label: 'Thinktank',
  value: '7cec77d5-2413-4c13-a8c3-f7fd945d7f62'
}, {
  label: 'UniBank',
  value: '1f2d2a24-30b8-11e9-b499-d663bd873d93'
}, {
  label: 'Victoria Teachers Mutual Bank',
  value: 'd2f87ca9-459b-4e3c-9eab-3de5fe493eac'
}, {
  label: 'Virgin Money',
  value: '3ed50cc9-e5b3-44ff-9e48-59c014f53d9d'
}, {
  label: 'Westpac',
  value: '768c5a93-06ed-423b-ba01-e0e645d45fd5'
}, {
  label: 'Westpac (Commercial)',
  value: '61203741-0bf1-44d1-aaed-b906e28271d2'
}];

var _PayloadLabel, _PayloadError, _devPayloadMap, _stgPayloadMap, _preprodPayloadMap, _prodPayloadMap, _defaultFormStatus;
var COMPLAINT_CATEGORY_OPTIONS = [{
  label: 'Credit Assistance',
  value: 'Credit Assistance'
}, {
  label: 'Credit Report',
  value: 'Credit Report'
}, {
  label: 'Product',
  value: 'Product'
}, {
  label: 'Other',
  value: 'Other'
}];
var COMPLAINT_ISSUE_OPTIONS = [{
  value: 'Break Costs',
  label: 'Break Costs'
}, {
  value: 'Best Interest Duty',
  label: 'Best Interest Duty'
}, {
  value: 'Commissions',
  label: 'Commissions'
}, {
  value: 'Credit Decision',
  label: 'Credit Decision'
}, {
  value: 'Credit Report Enquiry/Score',
  label: 'Credit Report Enquiry/Score'
}, {
  value: 'Delay',
  label: 'Delay'
}, {
  value: 'Failure to Follow Instructions/Agreement',
  label: 'Failure to Follow Instructions/Agreement'
}, {
  value: 'Disclosure',
  label: 'Disclosure'
}, {
  value: 'Fees and Charges',
  label: 'Fees and Charges'
}, {
  value: 'Financial Difficulty/Debt Collection',
  label: 'Financial Difficulty/Debt Collection'
}, {
  value: 'Fraud',
  label: 'Fraud'
}, {
  value: 'General Service',
  label: 'General Service'
}, {
  value: 'Incorrect Information Provided',
  label: 'Incorrect Information Provided'
}, {
  value: 'Product Features',
  label: 'Product Features'
}, {
  value: 'Product Terms and Conditions',
  label: 'Product Terms and Conditions'
}, {
  value: 'Interest Rate',
  label: 'Interest Rate'
}, {
  value: 'Lack of Contact',
  label: 'Lack of Contact'
}, {
  value: 'Loss of Documents',
  label: 'Loss of Documents'
}, {
  value: 'Misrepresentation',
  label: 'Misrepresentation'
}, {
  value: 'Other',
  label: 'Other'
}, {
  value: 'Platform Issue',
  label: 'Platform Issue'
}, {
  value: 'Privacy and Confidentiality',
  label: 'Privacy and Confidentiality'
}, {
  value: 'Repayment History Information',
  label: 'Repayment History Information'
}, {
  value: 'Request for Information',
  label: 'Request for Information'
}, {
  value: 'Responsible Lending',
  label: 'Responsible Lending'
}, {
  value: 'Settlement',
  label: 'Settlement'
}, {
  value: 'Transactions',
  label: 'Transactions'
}, {
  value: 'Technical Issues',
  label: 'Technical Issues'
}, {
  value: 'Unconscionable Conduct',
  label: 'Unconscionable Conduct'
}, {
  value: 'Unsuitable Loan',
  label: 'Unsuitable Loan'
}, {
  value: 'Valuation',
  label: 'Valuation'
}];
var CONTACT_NUMBER = [{
  value: 'Email',
  label: 'Email'
}, {
  value: 'Phone',
  label: 'Phone'
}];
var GENDER_OPTIONS = [{
  value: 'Male',
  label: 'Male'
}, {
  value: 'Female',
  label: 'Female'
}, {
  value: 'Non-binary',
  label: 'Non-binary'
}, {
  value: 'Unknown or Not Applicable',
  label: 'Unknown or Not Applicable'
}];
var AGE_OPTIONS = [{
  value: 'Less than 18 years',
  label: 'Less than 18 years'
}, {
  value: '18-24 years',
  label: '18-24 years'
}, {
  value: '25-34 years',
  label: '25-34 years'
}, {
  value: '35-44 years',
  label: '35-44 years'
}, {
  value: '45-54 years',
  label: '45-54 years'
}, {
  value: '55-64 years',
  label: '55-64 years'
}, {
  value: '65-74 years',
  label: '65-74 years'
}, {
  value: '75 years and Over',
  label: '75 years and Over'
}, {
  value: 'Unknown or Not Applicable',
  label: 'Unknown or Not Applicable'
}];
var Payload = /*#__PURE__*/function (Payload) {
  Payload["ComplaintCategory"] = "ComplaintCategory";
  Payload["ComplaintIssue"] = "ComplaintIssue";
  Payload["IssueDetails"] = "IssueDetails";
  Payload["ExpectedOutcome"] = "ExpectedOutcome";
  Payload["TeamMemberId"] = "TeamMemberId";
  Payload["LenderId"] = "LenderId";
  Payload["PreferContactMethod"] = "PreferContactMethod";
  Payload["Subject"] = "Subject";
  Payload["Phone"] = "Phone";
  Payload["Email"] = "Email";
  Payload["Postcode"] = "Postcode";
  Payload["Gender"] = "Gender";
  Payload["Age"] = "Age";
  return Payload;
}({});
var PayloadLabel = (_PayloadLabel = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_PayloadLabel, Payload.ComplaintCategory, 'Complaint category'), Payload.ComplaintIssue, 'Complaint issue'), Payload.IssueDetails, 'What is your complaint about?'), Payload.ExpectedOutcome, 'What outcome are you seeking?'), Payload.TeamMemberId, 'Who is your broker? (optional)'), Payload.LenderId, 'Who is your lender? (optional)'), Payload.PreferContactMethod, 'Preferred contact method.'), Payload.Subject, 'Complaint lodged by'), Payload.Phone, 'Contact number'), Payload.Email, 'Email'), _defineProperty(_defineProperty(_defineProperty(_PayloadLabel, Payload.Postcode, 'What is your postcode? (optional)'), Payload.Gender, 'What is your gender? (optional)'), Payload.Age, 'What is your age? (optional)'));
var PayloadError = (_PayloadError = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_PayloadError, Payload.ComplaintCategory, 'Select a complaint category'), Payload.ComplaintIssue, 'Select a complaint issue'), Payload.IssueDetails, 'Enter your complaint details'), Payload.ExpectedOutcome, 'Enter the outcome you are seeking'), Payload.TeamMemberId, ''), Payload.LenderId, ''), Payload.PreferContactMethod, 'Select your preferred contact method'), Payload.Subject, 'Enter your full name'), Payload.Phone, 'Enter an AU mobile number starting with 04'), Payload.Email, 'Enter your preferred email address'), _defineProperty(_defineProperty(_defineProperty(_PayloadError, Payload.Postcode, ''), Payload.Gender, ''), Payload.Age, ''));
var devPayloadMap = (_devPayloadMap = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_devPayloadMap, Payload.ComplaintCategory, '00N9D000007lzWv'), Payload.ComplaintIssue, '00N9D000007lzWw'), Payload.IssueDetails, '00N9D000005iqvm'), Payload.ExpectedOutcome, '00N9D000005iqvn'), Payload.TeamMemberId, '00N9D0000085IDO'), Payload.LenderId, '00N9D0000085IDN'), Payload.Subject, 'subject'), Payload.PreferContactMethod, '00N9D000005iqvp'), Payload.Phone, 'phone'), Payload.Email, 'email'), _defineProperty(_defineProperty(_defineProperty(_devPayloadMap, Payload.Postcode, '00N9D000007YC1k'), Payload.Gender, '00N9D000007YC1i'), Payload.Age, '00N9D000007YC1h'));
var stgPayloadMap = (_stgPayloadMap = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_stgPayloadMap, Payload.ComplaintCategory, '00N0p00000AaYIW'), Payload.ComplaintIssue, '00N0p00000AaYIX'), Payload.IssueDetails, '00N0p000008bHyb'), Payload.ExpectedOutcome, '00N0p000008bHyc'), Payload.TeamMemberId, '00N0p00000AdBkw'), Payload.LenderId, '00N0p00000AdBkv'), Payload.Subject, 'subject'), Payload.PreferContactMethod, '00N0p000008bHye'), Payload.Phone, 'phone'), Payload.Email, 'email'), _defineProperty(_defineProperty(_defineProperty(_stgPayloadMap, Payload.Postcode, '00N0p00000AA0Zb'), Payload.Gender, '00N0p00000AA0ZZ'), Payload.Age, '00N0p00000AA0ZY'));
var preprodPayloadMap = (_preprodPayloadMap = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_preprodPayloadMap, Payload.ComplaintCategory, '00N1y00000DRcKF'), Payload.ComplaintIssue, '00N1y000008xbIi'), Payload.IssueDetails, '00N0p000008bHyb'), Payload.ExpectedOutcome, '00N1y000008xbIj'), Payload.TeamMemberId, '00N1y00000DTu80'), Payload.LenderId, '00N1y00000DTu7z'), Payload.Subject, 'subject'), Payload.PreferContactMethod, '00N1y000008xbIl'), Payload.Phone, 'phone'), Payload.Email, 'email'), _defineProperty(_defineProperty(_defineProperty(_preprodPayloadMap, Payload.Postcode, '00N1y00000CJbu2'), Payload.Gender, '00N1y00000CJbu0'), Payload.Age, '00N1y00000CJbtz'));
var prodPayloadMap = (_prodPayloadMap = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_prodPayloadMap, Payload.ComplaintCategory, '00N9g000000PH0R'), Payload.ComplaintIssue, '00N9g000000PH0S'), Payload.IssueDetails, '00N5g00000ScDJg'), Payload.ExpectedOutcome, '00N5g00000ScDJh'), Payload.TeamMemberId, '00N9g000000PTyJ'), Payload.LenderId, '00N9g000000PTyI'), Payload.Subject, 'subject'), Payload.PreferContactMethod, '00N5g00000ScDJj'), Payload.Phone, 'phone'), Payload.Email, 'email'), _defineProperty(_defineProperty(_defineProperty(_prodPayloadMap, Payload.Postcode, '00N9g000000OnE6'), Payload.Gender, '00N9g000000OnE4'), Payload.Age, '00N9g000000OnE3'));
var DEV_PAYLOAD = {
  retURL: 'https://www.lendi-dev.net/about-us/contact-us/complaint-form/',
  orgid: '00D9D0000008fI9',
  recordType: '0129D000001KGoQ',
  owner: '00G9D000002u5oq',
  '00N9D000005mOXo': 'Lendi'
};
var STG_PAYLOAD = {
  retURL: 'https://www.lendi-stg.net/about-us/contact-us/complaint-form/',
  orgid: '00D0p0000008eZJ',
  recordType: '0120p000001Neg9',
  owner: '00G0p00000Nb3z3',
  '00N0p000008cHU8': 'Lendi'
};
var PREPROD_PAYLOAD = {
  retURL: 'https://www.lendi-preprod.net/about-us/contact-us/complaint-form/',
  orgid: '00D1y0000001EKg',
  recordType: '0121y000001lpax',
  owner: '00G1y000003ibnL',
  '00N1y000009F9EU': 'Lendi'
};
var PROD_PAYLOAD = {
  retURL: 'https://www.lendi.com.au/about-us/contact-us/complaint-form/',
  orgid: '00D5g0000063iKf',
  recordType: '0125g000000iUa5',
  owner: '00G5g0000015WN7',
  '00N5g00000ScVin': 'Lendi'
};
var Environment = /*#__PURE__*/function (Environment) {
  Environment["DEV"] = "development";
  Environment["STG"] = "staging";
  Environment["PREPROD"] = "preproduction";
  Environment["PROD"] = "production";
  return Environment;
}({});
var DEFAULT_PAYLOAD = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, Environment.DEV, DEV_PAYLOAD), Environment.STG, STG_PAYLOAD), Environment.PREPROD, PREPROD_PAYLOAD), Environment.PROD, PROD_PAYLOAD);
var PAYLOAD_MAP = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, Environment.DEV, devPayloadMap), Environment.STG, stgPayloadMap), Environment.PREPROD, preprodPayloadMap), Environment.PROD, prodPayloadMap);
var defaultFormStatus = (_defaultFormStatus = {}, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defaultFormStatus, Payload.ComplaintCategory, {
  value: '',
  isError: true
}), Payload.ComplaintIssue, {
  value: '',
  isError: true
}), Payload.IssueDetails, {
  value: '',
  isError: true
}), Payload.ExpectedOutcome, {
  value: '',
  isError: true
}), Payload.TeamMemberId, {
  value: ''
}), Payload.LenderId, {
  value: ''
}), Payload.PreferContactMethod, {
  value: '',
  isError: true
}), Payload.Subject, {
  value: '',
  isError: true
}), Payload.Phone, {
  value: '',
  isError: true
}), Payload.Email, {
  value: '',
  isError: true
}), _defineProperty(_defineProperty(_defineProperty(_defaultFormStatus, Payload.Postcode, {
  value: ''
}), Payload.Gender, {
  value: ''
}), Payload.Age, {
  value: ''
}));
var API = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, Environment.DEV, 'https://lendigroup--dev.sandbox.my.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8'), Environment.STG, 'https://lendigroup--staging.sandbox.my.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8'), Environment.PREPROD, 'https://lendigroup--preprod.sandbox.my.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8'), Environment.PROD, 'https://webto.salesforce.com/servlet/servlet.WebToCase?encoding=UTF-8');
var URL_SEARCH_KEY = /*#__PURE__*/function (URL_SEARCH_KEY) {
  URL_SEARCH_KEY["SUCCESS"] = "success";
  URL_SEARCH_KEY["EMAIL"] = "email";
  return URL_SEARCH_KEY;
}({});

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12;
var Wrapper = styled(Container)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n"])), my('md'));
var StyledHeading = styled(Heading)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: block;\n\n  small {\n    font-size: 18px;\n  }\n"])));
var StyledUnit = styled(Grid.Unit)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  ", "\n  row-gap: 6px;\n\n  &:last-child {\n    ", "\n  }\n\n  & > div {\n    width: 100%;\n  }\n"])), mb('md'), mb('nil'));

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var StyledLendiTooltip = styled(LendiTooltip)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  p {\n    margin: 0;\n  }\n"])));
var Calculator = styled.form(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  background-color: #f8f8f8;\n  border-radius: 5px;\n  ", "\n"])), p({
  lg: 'lg',
  xs: 'md'
}));

// eslint-disable-next-line @typescript-eslint/no-explicit-any
var StyledSelect = styled(Select)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  div {\n    ", "\n  }\n"])), fg('shade.500'));
var Title = styled(Heading)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  font-weight: 700;\n  ", "\n"])), mb('sm'));

// ------------------------

var FormContainer = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  button {\n    margin-bottom: 3rem;\n  }\n  textarea {\n    resize: auto;\n  }\n"])));
styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  width: 100%;\n  display: flex;\n  row-gap: 1.5rem;\n  flex-direction: column;\n  ", "\n"])), gte('sm')(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n    flex-direction: row;\n    column-gap: 1.5rem;\n    row-gap: 0;\n  "]))));
var ErrorListItem = styled.li(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  a {\n    color: ", ";\n  }\n"])), function () {
  return getColour('interaction', 'error');
});
var StyledAlert = styled(Alert)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  margin-bottom: 1.5rem;\n  & > :last-child p {\n    margin-left: 28px;\n  }\n"])));

var validateEmpty = function validateEmpty(value) {
  return !value;
};
var validatePhone = function validatePhone(value) {
  return value && value.length === 10 && value.indexOf('04') === 0;
};
var scrollIntoViewWithOffset = function scrollIntoViewWithOffset(targetElement) {
  if (!targetElement) return;
  if (typeof window !== 'undefined') {
    var headerOffset = 96;
    var elementOffset = targetElement.offsetTop;
    window.scrollTo(0, elementOffset - headerOffset);
  }
};

var ErrorBox = function ErrorBox(_ref) {
  var fieldErrorList = _ref.fieldErrorList,
    pageError = _ref.pageError;
  var onLinkClick = function onLinkClick(id) {
    return function (e) {
      e.preventDefault();
      var input = document.getElementById(id);
      scrollIntoViewWithOffset(input);
      input === null || input === void 0 || input.focus();
    };
  };
  if (pageError) {
    return /*#__PURE__*/jsx(StyledAlert, {
      heading: "Submit error",
      variant: "error",
      id: "error-box",
      children: /*#__PURE__*/jsx(Text, {
        tag: "p",
        variant: "detail1",
        appearance: "error",
        children: pageError
      })
    });
  } else if (fieldErrorList.length > 0) {
    return /*#__PURE__*/jsxs(StyledAlert, {
      heading: "Submit error",
      variant: "error",
      id: "error-box",
      children: [/*#__PURE__*/jsx(Text, {
        tag: "p",
        variant: "detail1",
        appearance: "error",
        children: "Please complete the fields below to submit"
      }), /*#__PURE__*/jsx("ul", {
        children: fieldErrorList.map(function (field) {
          return /*#__PURE__*/jsx(ErrorListItem, {
            children: /*#__PURE__*/jsx(Text, {
              tag: "span",
              align: "left",
              variant: "detail1",
              appearance: "error",
              children: /*#__PURE__*/jsx("a", {
                href: "#",
                onClick: onLinkClick(field[0]),
                children: PayloadError[field[0]]
              })
            })
          }, "".concat(field[0], "-key"));
        })
      })]
    });
  }
  return null;
};
var getItemByValue = function getItemByValue(options, value) {
  return options.find(function (o) {
    return o.value === value;
  });
};
var ComplaintForm = function ComplaintForm(_ref2) {
  var getBrokerList = _ref2.getBrokerList;
  var _useState = useState(defaultFormStatus),
    _useState2 = _slicedToArray(_useState, 2),
    form = _useState2[0],
    updateForm = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    touched = _useState4[0],
    setIsTouched = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    setBrokerList = _useState6[1];
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    pageError = _useState8[0],
    setPageError = _useState8[1];
  var environment = process.env.GATSBY_ENVIRONMENT;
  var params = typeof window !== 'undefined' ? new URLSearchParams(window.location.search) : undefined;
  var isSuccess = useMemo(function () {
    return !!(params !== null && params !== void 0 && params.get(URL_SEARCH_KEY.SUCCESS));
  }, []); // prevent rerender
  var paramEmail = sessionStorage.getItem(URL_SEARCH_KEY.EMAIL) || '';
  var api = API[environment || Environment.DEV];
  var onFormValueUpdate = function onFormValueUpdate(fieldName, formatter) {
    return function (eventOrValue) {
      var value = typeof eventOrValue === 'string' ? eventOrValue : eventOrValue.target.value;
      var formatted = formatter ? formatter(value) : value;
      var _form = _objectSpread({}, form);
      _form[fieldName] = {
        value: formatted
      };
      if (form[fieldName].isError !== undefined) {
        if (fieldName === Payload.Phone) {
          _form[fieldName].isError = !validatePhone(formatted);
        } else {
          _form[fieldName].isError = validateEmpty(formatted);
        }
      }
      updateForm(_form);
    };
  };
  useEffect(function () {
    getBrokerList().then(function (v) {
      setBrokerList([{
        label: 'Broker not listed',
        value: 'not_list'
      }, {
        label: 'I don’t remember',
        value: 'dont_remember'
      }].concat(v));
    });
  }, []);

  // init form value
  useEffect(function () {
    if (isSuccess) {
      if (typeof window !== 'undefined') {
        window.history.pushState({}, '', '/about-us/contact-us/complaint-form/'); // remove success query
        window.scrollTo(0, 0); // for lendi, when the page redirect, the window will keep the scroll status. So need to scroll to the top manually.
      }
      return;
    }
    var defaultPayload = DEFAULT_PAYLOAD[environment || Environment.DEV];
    var payloadMap = PAYLOAD_MAP[environment || Environment.DEV];
    Object.entries(form).forEach(function (_ref3) {
      var _ref4 = _slicedToArray(_ref3, 1),
        key = _ref4[0];
      var fieldKey = payloadMap[key];
      addFormData(fieldKey, '');
    });
    Object.entries(defaultPayload).forEach(function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
        key = _ref6[0],
        value = _ref6[1];
      addFormData(key, value);
    });
  }, []);
  var scrollToAndFocusErrorBox = function scrollToAndFocusErrorBox() {
    var errorBox = document.getElementById('error-box');
    scrollIntoViewWithOffset(errorBox);
    errorBox === null || errorBox === void 0 || errorBox.focus();
  };
  var addFormData = function addFormData(key, value) {
    var form = document.forms[0];
    if (form[key]) {
      form[key].value = value;
      return;
    }
    var newInput = document.createElement('input');
    newInput.hidden = true;
    newInput.name = key;
    newInput.value = value;
    form.appendChild(newInput);
  };
  var onSubmit = /*#__PURE__*/function () {
    var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(e) {
      var readyToSubmit, defaultPayload, payloadMap;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            setIsTouched(true);
            setPageError('');
            readyToSubmit = true;
            defaultPayload = DEFAULT_PAYLOAD[environment || Environment.DEV];
            payloadMap = PAYLOAD_MAP[environment || Environment.DEV];
            Object.entries(form).forEach(function (_ref8) {
              var _ref9 = _slicedToArray(_ref8, 2),
                key = _ref9[0],
                value = _ref9[1];
              if (value.isError) {
                readyToSubmit = false;
              }
              if (!!value.value) {
                var fieldKey = payloadMap[key];
                var finalValue = value.value;
                switch (key) {
                  case Payload.Subject:
                    finalValue = "New Webform Complaint raise by ".concat(finalValue);
                    break;
                  case Payload.Phone:
                    finalValue = "+61".concat(finalValue.substring(1, 10));
                    break;
                  case Payload.TeamMemberId:
                    if (finalValue === 'not_list' || finalValue === 'dont_remember') {
                      finalValue = '';
                    }
                }
                addFormData(fieldKey, finalValue);
              }
            });

            // handle return url
            addFormData('retURL', defaultPayload.retURL + "?".concat(URL_SEARCH_KEY.SUCCESS, "=1"));
            if (!readyToSubmit) {
              e.preventDefault();
              setTimeout(function () {
                return scrollToAndFocusErrorBox();
              }, 50); // react won't render the error box immediately, so need to run this with next render
            }
            sessionStorage.setItem(URL_SEARCH_KEY.EMAIL, form[Payload.Email].value);
          case 9:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function onSubmit(_x) {
      return _ref7.apply(this, arguments);
    };
  }();
  if (isSuccess) {
    return /*#__PURE__*/jsxs(Wrapper, {
      children: [/*#__PURE__*/jsx(StyledAlert, {
        variant: "success",
        heading: "Your complaint has been submitted successfully.",
        children: /*#__PURE__*/jsxs("p", {
          children: ["You will shortly receive an email acknowledging that we have received your Complaint. The email has been sent to ", paramEmail]
        })
      }), /*#__PURE__*/jsxs(Text, {
        tag: "p",
        variant: "body2",
        appearance: "subtle",
        children: ["Learn more about how we handle complaints by reading through the", ' ', /*#__PURE__*/jsx("a", {
          href: "/about-us/contact-us/complaints-resolution-process/",
          children: "complaints resolution policy."
        })]
      })]
    });
  }
  var fieldErrorList = Object.entries(form).filter(function (item) {
    return item[1].isError;
  });
  return /*#__PURE__*/jsxs(Wrapper, {
    children: [touched && /*#__PURE__*/jsx(ErrorBox, {
      pageError: pageError,
      fieldErrorList: fieldErrorList
    }), /*#__PURE__*/jsx(FormContainer, {
      children: /*#__PURE__*/jsxs(Calculator, {
        method: "POST",
        action: api,
        onSubmit: onSubmit,
        children: [/*#__PURE__*/jsx(Title, {
          size: 'sm',
          children: "What is your complaint?"
        }), /*#__PURE__*/jsx(Spacer, {
          ygap: "24",
          start: "32",
          children: /*#__PURE__*/jsxs(Grid, {
            children: [/*#__PURE__*/jsxs(Grid, {
              children: [/*#__PURE__*/jsxs(StyledUnit, {
                size: {
                  lg: 1 / 2,
                  sm: 1
                },
                children: [/*#__PURE__*/jsx(StyledHeading, {
                  size: "xxs",
                  children: PayloadLabel[Payload.ComplaintCategory]
                }), /*#__PURE__*/jsx(StyledSelect, {
                  id: Payload.ComplaintCategory,
                  isFullWidth: true,
                  options: COMPLAINT_CATEGORY_OPTIONS,
                  value: getItemByValue(COMPLAINT_CATEGORY_OPTIONS, form[Payload.ComplaintCategory].value),
                  onChangeItem: function onChangeItem(item) {
                    return onFormValueUpdate(Payload.ComplaintCategory)(item.value);
                  }
                }), form[Payload.ComplaintCategory].isError && touched && /*#__PURE__*/jsxs(Body, {
                  color: "error.500",
                  size: "xs",
                  children: [/*#__PURE__*/jsx(Error$1, {
                    color: "error.500"
                  }), " ", PayloadError[Payload.ComplaintCategory]]
                })]
              }), /*#__PURE__*/jsxs(StyledUnit, {
                size: {
                  lg: 1 / 2,
                  sm: 1
                },
                children: [/*#__PURE__*/jsx(StyledHeading, {
                  size: "xxs",
                  children: PayloadLabel[Payload.ComplaintIssue]
                }), /*#__PURE__*/jsx(StyledSelect, {
                  id: Payload.ComplaintIssue,
                  isFullWidth: true,
                  options: COMPLAINT_ISSUE_OPTIONS,
                  value: getItemByValue(COMPLAINT_ISSUE_OPTIONS, form[Payload.ComplaintIssue].value),
                  onChangeItem: function onChangeItem(item) {
                    return onFormValueUpdate(Payload.ComplaintIssue)(item.value);
                  }
                }), form[Payload.ComplaintIssue].isError && touched && /*#__PURE__*/jsxs(Body, {
                  color: "error.500",
                  size: "xs",
                  children: [/*#__PURE__*/jsx(Error$1, {
                    color: "error.500"
                  }), " ", PayloadError[Payload.ComplaintIssue]]
                })]
              })]
            }), /*#__PURE__*/jsxs(StyledUnit, {
              size: {
                lg: 1 / 1,
                xs: 1
              },
              children: [/*#__PURE__*/jsx("label", {
                htmlFor: Payload.IssueDetails,
                children: /*#__PURE__*/jsxs(StyledHeading, {
                  size: "xxs",
                  children: [PayloadLabel[Payload.IssueDetails], /*#__PURE__*/jsx(StyledLendiTooltip, {
                    content: "Include dates and other relevant details. As well as how we could do better. Don't include any confidential or personal account info.",
                    position: "right",
                    children: /*#__PURE__*/jsx(Help, {
                      height: "20px",
                      width: "20px",
                      color: "primary.600"
                    })
                  })]
                })
              }), /*#__PURE__*/jsx(TextArea, {
                size: "md",
                id: Payload.IssueDetails,
                isFullWidth: true,
                value: form[Payload.IssueDetails].value,
                onChange: onFormValueUpdate(Payload.IssueDetails),
                isError: touched && form[Payload.IssueDetails].isError
              }), form[Payload.IssueDetails].isError && touched && /*#__PURE__*/jsxs(Body, {
                color: "error.500",
                size: "xs",
                children: [/*#__PURE__*/jsx(Error$1, {
                  color: "error.500"
                }), " ", PayloadError[Payload.IssueDetails]]
              })]
            }), /*#__PURE__*/jsxs(StyledUnit, {
              size: {
                lg: 1 / 1,
                xs: 1
              },
              children: [/*#__PURE__*/jsx("label", {
                htmlFor: Payload.ExpectedOutcome,
                children: /*#__PURE__*/jsx(StyledHeading, {
                  size: "xxs",
                  children: PayloadLabel[Payload.ExpectedOutcome]
                })
              }), /*#__PURE__*/jsx(TextArea, {
                size: "md",
                id: Payload.ExpectedOutcome,
                isFullWidth: true,
                value: form[Payload.ExpectedOutcome].value,
                onChange: onFormValueUpdate(Payload.ExpectedOutcome),
                isError: touched && form[Payload.ExpectedOutcome].isError
              }), form[Payload.ExpectedOutcome].isError && touched && /*#__PURE__*/jsxs(Body, {
                color: "error.500",
                size: "xs",
                children: [/*#__PURE__*/jsx(Error$1, {
                  color: "error.500"
                }), " ", PayloadError[Payload.ExpectedOutcome]]
              })]
            }), /*#__PURE__*/jsx(Grid, {
              children: /*#__PURE__*/jsxs(StyledUnit, {
                size: {
                  lg: 1 / 1,
                  sm: 1
                },
                style: {
                  marginBottom: '24px'
                },
                children: [/*#__PURE__*/jsx(StyledHeading, {
                  size: "xxs",
                  children: PayloadLabel[Payload.LenderId]
                }), /*#__PURE__*/jsx(StyledSelect, {
                  id: Payload.LenderId,
                  isFullWidth: true,
                  options: LENDER_LIST,
                  value: getItemByValue(LENDER_LIST, form[Payload.LenderId].value),
                  onChangeItem: function onChangeItem(item) {
                    return onFormValueUpdate(Payload.LenderId)(item.value);
                  }
                }), form[Payload.LenderId].isError && touched && /*#__PURE__*/jsxs(Body, {
                  color: "error.500",
                  size: "xs",
                  children: [/*#__PURE__*/jsx(Error$1, {
                    color: "error.500"
                  }), " ", PayloadError[Payload.LenderId]]
                })]
              })
            })]
          })
        }), /*#__PURE__*/jsx(Title, {
          size: 'sm',
          children: "What are your details?"
        }), /*#__PURE__*/jsx(Spacer, {
          ygap: "24",
          end: "32",
          start: "32",
          children: /*#__PURE__*/jsxs(Grid, {
            children: [/*#__PURE__*/jsxs(StyledUnit, {
              size: {
                lg: 1 / 1,
                xs: 1
              },
              children: [/*#__PURE__*/jsx("label", {
                htmlFor: Payload.Subject,
                children: /*#__PURE__*/jsxs(StyledHeading, {
                  size: "xxs",
                  children: [PayloadLabel[Payload.Subject], /*#__PURE__*/jsx(StyledLendiTooltip, {
                    content: "Enter your full name and provide name of co-applicant/co-borrower if applicable",
                    position: "right",
                    children: /*#__PURE__*/jsx(Help, {
                      height: "20px",
                      width: "20px",
                      color: "primary.600"
                    })
                  })]
                })
              }), /*#__PURE__*/jsx(Input, {
                crossOrigin: undefined,
                id: Payload.Subject,
                onChange: onFormValueUpdate(Payload.Subject),
                value: form[Payload.Subject].value
              }), form[Payload.Subject].isError && touched && /*#__PURE__*/jsxs(Body, {
                color: "error.500",
                size: "xs",
                children: [/*#__PURE__*/jsx(Error$1, {
                  color: "error.500"
                }), " ", PayloadError[Payload.Subject]]
              })]
            }), /*#__PURE__*/jsxs(StyledUnit, {
              size: {
                lg: 1 / 1,
                sm: 1
              },
              children: [/*#__PURE__*/jsx(StyledHeading, {
                size: "xxs",
                children: PayloadLabel[Payload.PreferContactMethod]
              }), /*#__PURE__*/jsx(StyledSelect, {
                id: Payload.PreferContactMethod,
                isFullWidth: true,
                options: CONTACT_NUMBER,
                value: getItemByValue(CONTACT_NUMBER, form[Payload.PreferContactMethod].value),
                onChangeItem: function onChangeItem(item) {
                  return onFormValueUpdate(Payload.PreferContactMethod)(item.value);
                }
              }), form[Payload.PreferContactMethod].isError && touched && /*#__PURE__*/jsxs(Body, {
                color: "error.500",
                size: "xs",
                children: [/*#__PURE__*/jsx(Error$1, {
                  color: "error.500"
                }), " ", PayloadError[Payload.PreferContactMethod]]
              })]
            }), /*#__PURE__*/jsxs(Grid, {
              children: [/*#__PURE__*/jsxs(StyledUnit, {
                size: {
                  lg: 1 / 2,
                  xs: 1
                },
                children: [/*#__PURE__*/jsx("label", {
                  htmlFor: Payload.Phone,
                  children: /*#__PURE__*/jsxs(StyledHeading, {
                    size: "xxs",
                    children: [PayloadLabel[Payload.Phone], /*#__PURE__*/jsx(StyledLendiTooltip, {
                      content: "We accept Australian mobile numbers",
                      position: "right",
                      children: /*#__PURE__*/jsx(Help, {
                        height: "20px",
                        width: "20px",
                        color: "primary.600"
                      })
                    })]
                  })
                }), /*#__PURE__*/jsx(Input, {
                  crossOrigin: undefined,
                  id: Payload.Phone,
                  before: /*#__PURE__*/jsx("div", {
                    style: {
                      margin: '0 0.75rem'
                    },
                    children: /*#__PURE__*/jsx(Phone, {
                      height: "1.5rem",
                      width: "1.5rem"
                    })
                  }),
                  onChange: onFormValueUpdate(Payload.Phone, function (s) {
                    return "".concat(s).substring(0, 10);
                  }),
                  value: form[Payload.Phone].value
                }), form[Payload.Phone].isError && touched && /*#__PURE__*/jsxs(Body, {
                  color: "error.500",
                  size: "xs",
                  children: [/*#__PURE__*/jsx(Error$1, {
                    color: "error.500"
                  }), " ", PayloadError[Payload.Phone]]
                })]
              }), /*#__PURE__*/jsxs(StyledUnit, {
                size: {
                  lg: 1 / 2,
                  xs: 1
                },
                children: [/*#__PURE__*/jsx("label", {
                  htmlFor: Payload.Email,
                  children: /*#__PURE__*/jsx(StyledHeading, {
                    size: "xxs",
                    children: PayloadLabel[Payload.Email]
                  })
                }), /*#__PURE__*/jsx(Input, {
                  crossOrigin: undefined,
                  id: Payload.Email,
                  before: /*#__PURE__*/jsx("div", {
                    style: {
                      margin: '0 0.75rem'
                    },
                    children: /*#__PURE__*/jsx(Email, {
                      height: "1.5rem",
                      width: "1.5rem"
                    })
                  }),
                  onChange: onFormValueUpdate(Payload.Email),
                  value: form[Payload.Email].value
                }), form[Payload.Email].isError && touched && /*#__PURE__*/jsxs(Body, {
                  color: "error.500",
                  size: "xs",
                  children: [/*#__PURE__*/jsx(Error$1, {
                    color: "error.500"
                  }), " ", PayloadError[Payload.Email]]
                })]
              })]
            }), /*#__PURE__*/jsxs(StyledUnit, {
              size: {
                lg: 1 / 1,
                xs: 1
              },
              children: [/*#__PURE__*/jsx("label", {
                htmlFor: Payload.Postcode,
                children: /*#__PURE__*/jsx(StyledHeading, {
                  size: "xxs",
                  children: PayloadLabel[Payload.Postcode]
                })
              }), /*#__PURE__*/jsx(Input, {
                crossOrigin: undefined,
                id: Payload.Postcode,
                before: /*#__PURE__*/jsx("div", {
                  style: {
                    margin: '0 0.75rem'
                  },
                  children: /*#__PURE__*/jsx(Email, {
                    height: "1.5rem",
                    width: "1.5rem"
                  })
                }),
                onChange: onFormValueUpdate(Payload.Postcode),
                value: form[Payload.Postcode].value
              }), form[Payload.Postcode].isError && touched && /*#__PURE__*/jsxs(Body, {
                color: "error.500",
                size: "xs",
                children: [/*#__PURE__*/jsx(Error$1, {
                  color: "error.500"
                }), " ", PayloadError[Payload.Postcode]]
              })]
            }), /*#__PURE__*/jsxs(Grid, {
              children: [/*#__PURE__*/jsxs(StyledUnit, {
                size: {
                  lg: 1 / 2,
                  sm: 1
                },
                children: [/*#__PURE__*/jsx(StyledHeading, {
                  size: "xxs",
                  children: "What is your gender? (optional)"
                }), /*#__PURE__*/jsx(StyledSelect, {
                  id: Payload.Gender,
                  isFullWidth: true,
                  options: GENDER_OPTIONS,
                  value: getItemByValue(GENDER_OPTIONS, form[Payload.Gender].value),
                  onChangeItem: function onChangeItem(item) {
                    return onFormValueUpdate(Payload.Gender)(item.value);
                  }
                })]
              }), /*#__PURE__*/jsxs(StyledUnit, {
                size: {
                  lg: 1 / 2,
                  sm: 1
                },
                children: [/*#__PURE__*/jsx(StyledHeading, {
                  size: "xxs",
                  children: PayloadLabel[Payload.Age]
                }), /*#__PURE__*/jsx(StyledSelect, {
                  id: Payload.Age,
                  isFullWidth: true,
                  options: AGE_OPTIONS,
                  value: getItemByValue(AGE_OPTIONS, form[Payload.Age].value),
                  onChangeItem: function onChangeItem(item) {
                    return onFormValueUpdate(Payload.Age)(item.value);
                  }
                })]
              })]
            })]
          })
        }), /*#__PURE__*/jsx(Button, {
          variant: "primary",
          type: "submit",
          children: "Submit"
        }), /*#__PURE__*/jsxs(Text, {
          tag: "p",
          variant: "body2",
          appearance: "subtle",
          children: ["Learn more about how we handle complaints by reading through the", ' ', /*#__PURE__*/jsx("a", {
            href: "/about-us/contact-us/complaints-resolution-process/",
            children: "complaints resolution policy."
          })]
        })]
      })
    })]
  });
};

export { ComplaintForm };
